import React, { useState, useEffect } from 'react';
import { useSettings, useStore } from '../../listing-app/context/store';

export default function Search() {
    const { 
        state,
        dispatch 
    } = useStore();

    const settings = useSettings();

    const findRentals = () => {
        let url = settings.data.rentalsUrl + '?';
        for ( const key in state.filters ) {
            url += `${key}=${encodeURIComponent( state.filters[ key ] )}&`;
        }

        window.location.href = url;
    }

    if ( 'undefined' !== typeof settings && settings.filters.length && 'undefined' !== typeof state ) {
        return (
            <div className="filters-search-box">
                <button className="filters-search-box__button" onClick={ () => findRentals() }>Find Rentals</button>
            </div>
        )
    }

    return '';
}